import {
  Box,
  Flex,
  Icon,
  Image,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Tooltip,
} from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import blank from "./blank.png";
import { MdPause, MdPlayArrow } from "react-icons/md";
import { Coordinate } from "~/generated/graphql.types";
import { HyperlapseImage } from "~/routes/_shared/types";

export const HyperlapsePlayer = ({
  images,
  onChangeFrame = () => {},
}: {
  images?: HyperlapseImage[];
  onChangeFrame?: (args: {
    i: number;
    coordinate: Coordinate;
    heading: number;
  }) => void;
}) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const [current, setCurrent] = useState<string | undefined>();
  const [lastImageIndex, setLastImageIndex] = useState(0);
  const [currentIntervalId, setCurrentIntervalId] = useState<any>();
  const [speedDenominator, setSpeedDenominator] = useState(30);
  const millisecondsPerFrame = useMemo(() => {
    const coefficient = 100 / (speedDenominator + 1);
    return coefficient * 120;
  }, [speedDenominator]);

  useEffect(() => {
    setLastImageIndex(0);
  }, [images]);

  useEffect(() => {
    if (!images) return;

    if (currentIntervalId) {
      clearInterval(currentIntervalId);
    }

    let i = lastImageIndex;
    const id = setInterval(() => {
      if (!isPlaying) return;

      const image = images[i];
      setCurrent(image.fileName ? `${image.fileName}` : undefined);
      onChangeFrame({
        i,
        coordinate: {
          lat: image.location.lat,
          lon: image.location.lng,
        },
        heading: image.heading,
      });
      i++;
      if (i >= images.length) i = 0;
    }, millisecondsPerFrame);
    setCurrentIntervalId(id);

    return () => {
      setLastImageIndex(i);
      clearInterval(id);
    };
    // images が変わるたびに止めるためcurrentIntervalIdは含めない
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images, millisecondsPerFrame, isPlaying]);

  return (
    <Box width="100%" height="100%" backgroundColor={"black"}>
      <Image src={current || blank} w="100%" m="auto" pointerEvents={"none"} />
      <Flex
        bgColor="black"
        px={2}
        py={2}
        justifyContent="space-between"
        alignItems="center"
      >
        {isPlaying ? (
          <Icon
            color="white"
            fontSize="2xl"
            as={MdPause}
            onClick={() => setIsPlaying(false)}
          />
        ) : (
          <Icon
            color="white"
            fontSize="2xl"
            as={MdPlayArrow}
            onClick={() => setIsPlaying(true)}
          />
        )}
        <Slider
          aria-label="slider-ex-1"
          defaultValue={speedDenominator}
          w="10rem"
          onChange={setSpeedDenominator}
        >
          <SliderTrack>
            <SliderFilledTrack />
          </SliderTrack>
          <Tooltip hasArrow placement="top" label="速度を変更">
            <SliderThumb />
          </Tooltip>
        </Slider>
      </Flex>
    </Box>
  );
};
